// Sign-in through the auth-otp edge function (IMPLEMENTATION_PLAN §5): the server decides, rate-limits and logs;
// the browser only sends the identifier, then the code, and stores the returned session. The client itself is
// shared with the mobile app (@fleetspoke/core/auth).

import { type AuthError, type Identifier, otpClient } from '@fleetspoke/core/auth';
import { appConfig, supabase } from './supabase';

export { parseIdentifier } from '@fleetspoke/core/auth';
export type { AuthError, Channel, Identifier } from '@fleetspoke/core/auth';

const client = otpClient(appConfig);

export function requestCode(id: Identifier): Promise<AuthError | null> {
  return client.requestCode(id);
}

export async function verifyCode(id: Identifier, code: string): Promise<AuthError | null> {
  const result = await client.verifyCode(id, code);
  if (typeof result === 'string') return result;
  const { error } = await supabase().auth.setSession(result);
  return error ? 'unavailable' : null;
}
